<template>
    <div class="d-flex" :class="col">
        <loading :active.sync="loader" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="card flex-fill border border-warning riseup-mp">
            <center><img class="card-img-top" src="images/falah-logo.png" alt="Card image cap"></center>
            <div class="card-body">
                <p class="text-justify">Multi-sectoral and multi-purpose funding window for Muslim-owned enterprises, excluding all haram-related industries.</p>
            </div>
            <div class="card-footer bg-none mx-auto">
                <button type="button" class="btn btn-success btn-lg px-5" data-toggle="modal" data-target="#modalFalah">APPLY</button>
            </div>
        </div>


        <div class="modal fade" id="modalFalah" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Which FALAH Financing product are you applying for?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row px-md-4">
                            <div class="col-lg-4 d-flex" v-for="(item, index) in program" :key="index">
                                <div class="card flex-fill bg-gray">
                                    <div class="card-body">
                                        <h4 class="bold text-center bl">{{ item.program_name }}</h4>
                                        <p class="text-justify bl">{{ item.menu_desc }}</p>
                                    </div>
                                    <div class="card-footer bg-none mx-auto">
                                        <button type="button" class="btn btn-success btn-lg px-5" @click="selectedLoan(item)">APPLY</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="modalFalahFT" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Documentary Requirements</h5>
                    </div>
                    <div class="modal-body">

                        <div class="card-body mt-n3">
                            <ul style="list-style: '-  '; margin-left: -20px;">
                                <li>At least one (1) valid ID of the sole proprietor / managing partner / President / CEO</li>
                                <li>A selfie holding the same ID</li>
                                <li>For partnerships and corporations, Secretary’s Certificate or Board Resolution or Partnership Resolution that authorizes the President/CEO/managing partner to negotiate/obtain a loan from SB Corporation.</li>
                                <li>Latest General Information Sheet (for corporations) or Articles of Partnership (for partnerships).</li>
                                <li>Proof of bank account or electronic money account (must be under the name of the sole proprietor, sole proprietorship, partnership, or corporation).</li>
                                <li>Barangay Permit for loan up to PhP100.0 thousand</li>
                                <li>Mayor’s Permit or Barangay Micro Business Enterprise (BMBE) Certificate for loan More than PhP100.0 thousand </li>
                            </ul>


                            <p class="card-text mt-1">- Three (3) pictures showing the following:</p>
                            <ul style="list-style: none; margin-left: -10px;">
                                <li>a. Business signage;</li>
                                <li>b. Inventories; and,</li>
                                <li>c. Fixed assets</li>
                            </ul>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button data-dismiss="modal" class="btn btn-outline-primary"><i class="fas fa-times mr-1"></i>Cancel</button>
                        <button type="button" class="btn btn-primary" @click="selectedFT()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalFalahSuki" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">For Falah Suki Loan</h5>
                    </div>
                    <div class="modal-body">
                        <alert-dismissible :category="'alert-danger2'" :toggle="submitting && $v.formSuki.$error">
                            <template v-slot:content>
                                <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                            </template>
                        </alert-dismissible>

                        <div class="alert alert-danger2 alert-dismissible mb-2" role="alert" v-if="msg">
                            <button type="button" class="close mt-n1" data-dismiss="alert" @click="msg=null">&times;</button>
                            <p class="text-justify p-0 m-0">{{msg}}</p>
                        </div>
                        <div class="form-group">
                            <label>Select Business Type</label>
                            <select class="form-control custom-select-sm" v-model="formSuki.bus_type" :class="{'is-invalid': submitting && $v.formSuki.bus_type.$error}">
                                <option selected disabled :value='null'>- Select -</option>
                                <option value="BT2020001">Sole Proprietorship</option>
                                <option value="BT2020002">Partnership</option>
                                <option value="BT2020004">Corporation</option>
                                <option value="BT2020003">Cooperative</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="formSuki.bus_type && formSuki.bus_type != 'BT2020001'">
                            <label>Please enter your Business Name</label>
                            <input class="form-control text-uppercase" v-model="formSuki.bus_name" :class="{'is-invalid': submitting && $v.formSuki.bus_name.$error}" />
                        </div>
                        <div class="form-group">
                            <label>Please enter your Promissory Note Number</label>
                            <input class="form-control text-uppercase" v-model="formSuki.pnno" :class="{'is-invalid': submitting && $v.formSuki.pnno.$error}">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-sm mr-auto" @click="formSuki.pnno=null,formSuki.bus_type=null,formSuki.bus_name=null,msg=null" data-dismiss="modal"><i class="fas fa-times mr-1"></i>Cancel</button>
                        <button type="button" class="btn btn-primary btn-sm" @click="getRiseUpSuki()">Submit<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalFalahSukiList" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">Documentary Requirements</h5>
                    </div>
                    <div class="modal-body">
                        <div class="card-body mt-n3">
                            <p class="card-text bold">If for Fixed assets acquisition</p>
                            <ul style="list-style: '-  '; margin-left: -20px;">
                                <li>Latest GIS (for corporations)</li>
                                <li>Articles of Partnership (for partnerships)</li>
                                <li>Mayor’s Permit (for the current year)</li>
                                <li>Secretary’s Certificate or Board Resolution or Partnership Resolution</li>
                                <li>Proof of Bank Account or Electronic Money Account</li>
                                <!-- <li>Three (3) photos and one (1) one-minute video showing the business signage, inventories, and fixed assets</li> -->
                                <li>Three (3) photos showing the business signage, inventories, and fixed assets</li>
                            </ul>
                            <hr>
                            <p class="card-text bold">For Other Loan Purpose</p>
                            <ul style="list-style: '-  '; margin-left: -20px;">
                                <li>Latest GIS (for corporations)</li>
                                <li>Articles of Partnership (for partnerships)</li>
                                <li>Mayor’s Permit (for the current year)</li>
                                <li>Secretary’s Certificate or Board Resolution or Partnership Resolution</li>
                                <li>Proof of Bank Account or Electronic Money Account</li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="nextSuki()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import AlertDismissible from "@vues/alerts/AlertDismissible.vue";
    import {
        required,
        requiredIf
    } from 'vuelidate/lib/validators';
    export default {
        components: {
            AlertDismissible,
        },
        props: {
            col: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                loader: false,
                menu: [],
                program: [],
                form: null,
                formSuki: {
                    pnno: null,
                    bus_type: null,
                    bus_name: null,
                },
                submitting: false,
                msg: null
            }
        },
        validations: {
            formSuki: {
                pnno: {
                    required
                },
                bus_type: {
                    required
                },
                bus_name: {
                    required: requiredIf(function() {
                        if (this.formSuki.bus_type == 'BT2020001') {
                            return false;
                        }
                        return true;
                    })
                },
            },
        },
        created() {
            this.getMenu();
        },
        methods: {
            nextSuki() {
                $('#modalFalahSukiList').modal('hide');
                this.$router.push('/apply-loan/sblaf-falah-suki');
            },
            sukiValidate() {
                this.loader = true;
                axios.post('/api/falah-suki-qualification', {
                        pnno: this.formSuki.pnno,
                        bus_type: this.formSuki.bus_type,
                        bus_name: this.formSuki.bus_name,
                        app_id_prefix: this.form.app_id_prefix,
                        app_id_suffix: this.form.app_id_suffix,
                        loan_bus_code: this.form.loan_bus_code
                    })
                    .then(response => {
                        let res = response.data;
                        if (res.status == 0) {
                            this.msg = res.message
                        }
                        if (res.status == 1) {
                            $('#modalFalahSuki').modal('hide');
                            $('#modalFalahSukiList').modal('show');
                        }
                        this.loader = false;
                    }).catch(err => {
                        this.loader = false;
                    })
            },

            getRiseUpSuki() {
                this.submitting = true;
                this.$v.formSuki.$touch();
                if (this.$v.formSuki.$invalid) {} else {
                    this.sukiValidate();
                }
            },

            apiFalahRegistry(form) {
                this.loader = true;
                axios.post('/api/falah-qualification', {
                        app_id_prefix: form.app_id_prefix,
                        app_id_suffix: form.app_id_suffix,
                        loan_bus_code: form.loan_bus_code
                    })
                    .then(res => {
                        this.loader = false;
                        const data = res.data.loan_process;

                        const mapRoute = {
                            'FIB21': '/sblaf-falah-mp',
                            'FIB22': '/sblaf-falah-ft',
                        };
                        this.$router.push('/apply-loan' + mapRoute[data.loan_type]);
                    }).catch(err => {
                        this.loader = false;
                    })
            },
            selectedLoan(form) {
                this.form = form;
                $('#modalFalah').modal('hide');
                if (form.loan_bus_code == 'FIB22') {
                    $('#modalFalahFT').modal('show');
                } else if (form.loan_bus_code == 'FIB23') {
                    $('#modalFalahSuki').modal('show');
                } else {
                    this.apiFalahRegistry(this.form);
                }
            },
            selectedFT() {
                $('#modalFalahFT').modal('hide');
                this.apiFalahRegistry(this.form);
            },
            getMenu() {
                axios.get('/api/sblaf-menu-falah')
                    .then(res => {
                        let data = res.data;
                        this.program = data.program;
                    }).catch(err => {})
            },
        },
        computed: {},
        mounted() {}
    }
</script>
<style scoped>
    .alert-danger2 {
        color: #721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }

    .riseup-mp {
        border-color: #fe9900 !important;
        border-width: 7px !important
    }

    .riseup-turismo {
        border-color: #263d81 !important;
        border-width: 7px !important
    }

    .riseup-tindahan {
        /* border-color: #78a236 !important; */
        border-width: 7px !important
    }

    .bg-none {
        background-color: transparent !important;
    }

    .bl {
        color: black;
    }

    .bg-gray {
        background-color: #f3f3f3 !important;
    }

    .bg-gray2 {
        background-color: #E5E5E5 !important;
    }
</style>